<template>
  <svg class="icon-mail" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(1 2)" :stroke="color" stroke-width="1.5" fill="none" fill-rule="evenodd">
      <rect x=".75" y=".75" width="12.5" height="10.5" rx="1"/>
      <path
          d="M7 7.136l6.124-3.5c.078.056.126-.127.126-.216V1A.25.25 0 0 0 13 .75H1A.25.25 0 0 0 .75 1v2.42c0 .09.048.172.126.217L7 7.137z"/>
    </g>
  </svg>
</template>

<script>
  export default {
    name: "IconMail",
    props: {
      color: {
        default: '#394BE5',
        type: String,
      },
    },
  }
</script>

<style scoped>

  .icon-mail {
    width: 0.16rem;
    height: 0.16rem;
  }

</style>